import { useState, useEffect } from "react";
import { getUserData } from "../../utils/api/getUserData.js";
import { updateProfile } from "../../utils/api/updateProfile.js";

export function ProfilePage1(user) {

  const[userData, setUserData] = useState({
    name:"",
    surname:"",
    lastname:"",
    email:"",
    user_name:"",
    birthDateYear:"1940",
    birthDateMonth:"1",
    birthDateDay:"1",
    docExpirationYear:"2030",
    docExpirationMonth:"1",
    docType: "D",
    nationality: "ESP",
    docNumber: ""
  });

  const loadUserData = async () => {
    const loadedUserData = await getUserData(user);
    setUserData(loadedUserData.data);
  }

  const handleEdit = async () => {
    const response = await updateProfile(user, userData);
    if(response){

    }
  }

  useEffect(() => {
    // cargar datos de usuario
    loadUserData();
  }, []);

  const handleNameChange = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      name: newName,
    }));
  };

  const handleSurnameChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      surname: newData,
    }));
  };

  const handleLastnameChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      lastname: newData,
    }));
  };

  const handleSexChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      sex: newData,
    }));
  };


  const handleDocTypeChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      docType: newData,
    }));
  };

  const handleDocNumberChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      docNumber: newData,
    }));
  };

  const handleDocExpirationMonthChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      docExpirationMonth: newData,
    }));
  };

  const handleDocExpirationYearChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      docExpirationYear: newData,
    }));
  };

  const handleBirthDateDayChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      birthDateDay: newData,
    }));
  };

  const handleBirthDateMonthChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      birthDateMonth: newData,
    }));
  };

  const handleBirthDateYearChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      birthDateYear: newData,
    }));
  };

  const handleNationalityChange = (event) => {
    const newData = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      nationality: newData,
    }));
  };


  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
              <br/>
              <span className="ht-body-bold uppercase">MI PERFIL</span><br/>
              <span className="ht-body-regular">Edita tus datos personales</span>
          </header>
          <div className="m-frmGroup total">
            <label for="nombre">Nombre</label>
            <input placeholder="Nombre" type="text"  name="user[name]" id="user_name" value={userData.name} onChange={handleNameChange}/>
          </div>
          <div className="m-frmGroup">
            <label for="primerApellido">Primer apellido</label>
            <input placeholder="Primer apellido" type="text"  name="user[surname]" id="user_surname" value={userData.surname} onChange={handleSurnameChange}/>
          </div>
          <div className="m-frmGroup">
            <label for="segundoApellido">Segundo apellido</label>
            <input placeholder="Segundo apellido" type="text"  name="user[lastname]" id="user_lastname" value={userData.lastname} onChange={handleLastnameChange}/>
          </div>
          <div className="m-frmGroup">
            <label for="sexo">
              Sexo
            </label>
            <select className="" name="user[sex]" id="user_sex" value={userData.sex} onChange={handleSexChange}>
              <option selected="selected" value="H">Hombre</option>
              <option value="M">Mujer</option>
            </select>
          </div>
          <div className="m-frmGroup m-frmNaci">
            <span className="m-frmNaci__tit">Fecha de nacimiento</span>
            <div className="m-frmGroup m-frmGroup--min">
              <label for="diaNac">Día</label>
              <select name="birth_date_day" id="birth_date_day" value={userData.birth_date_day} onChange={handleBirthDateDayChange}>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </select>
            </div>
            <div className="m-frmGroup m-frmGroup--min">
              <label for="mesNac">Mes</label>
              <select name="birth_date_month" id="birth_date_month" value={userData.birth_date_month} onChange={handleBirthDateMonthChange}>
                <option value="1">Enero</option>
                <option value="2">Febrero</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
            </div>
            <div className="m-frmGroup m-frmGroup--min">
              <label for="anoNac">Año</label>
              <select id="birth_date_year" name="birth_date_year" value={userData.birth_date_year} onChange={handleBirthDateYearChange}>
                <option value="1940">1940</option>
                <option value="1941">1941</option>
                <option value="1942">1942</option>
                <option value="1943">1943</option>
                <option value="1944">1944</option>
                <option value="1945">1945</option>
                <option value="1946">1946</option>
                <option value="1947">1947</option>
                <option value="1948">1948</option>
                <option value="1949">1949</option>
                <option value="1950">1950</option>
                <option value="1951">1951</option>
                <option value="1952">1952</option>
                <option value="1953">1953</option>
                <option value="1954">1954</option>
                <option value="1955">1955</option>
                <option value="1956">1956</option>
                <option value="1957">1957</option>
                <option value="1958">1958</option>
                <option value="1959">1959</option>
                <option value="1960">1960</option>
                <option value="1961">1961</option>
                <option value="1962">1962</option>
                <option value="1963">1963</option>
                <option value="1964">1964</option>
                <option value="1965">1965</option>
                <option value="1966">1966</option>
                <option value="1967">1967</option>
                <option value="1968">1968</option>
                <option value="1969">1969</option>
                <option value="1970">1970</option>
                <option value="1971">1971</option>
                <option value="1972">1972</option>
                <option value="1973">1973</option>
                <option value="1974">1974</option>
                <option value="1975">1975</option>
                <option value="1976">1976</option>
                <option value="1977">1977</option>
                <option value="1978">1978</option>
                <option value="1979">1979</option>
                <option value="1980">1980</option>
                <option value="1981">1981</option>
                <option value="1982">1982</option>
                <option value="1983">1983</option>
                <option value="1984">1984</option>
                <option value="1985">1985</option>
                <option value="1986">1986</option>
                <option value="1987">1987</option>
                <option value="1988">1988</option>
                <option value="1989">1989</option>
                <option value="1990">1990</option>
                <option value="1991">1991</option>
                <option value="1992">1992</option>
                <option value="1993">1993</option>
                <option value="1994">1994</option>
                <option value="1995">1995</option>
                <option value="1996">1996</option>
                <option value="1997">1997</option>
                <option value="1998">1998</option>
                <option value="1999">1999</option>
                <option value="2000">2000</option>
                <option value="2001">2001</option>
                <option value="2002">2002</option>
                <option value="2003">2003</option>
                <option value="2004">2004</option>
                <option value="2005">2005</option>
                <option value="2006">2006</option>
                <option value="2007">2007</option>
                <option value="2008">2008</option>
                <option value="2009">2009</option>
                <option value="2010">2010</option>
                <option value="2011">2011</option>
                <option value="2012">2012</option>
                <option value="2013">2013</option>
                <option value="2014">2014</option>
                <option value="2015">2015</option>
                <option value="2016">2016</option>
                <option value="2017">2017</option>
                <option value="2018">2018</option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
              </select>

            </div>
          </div>
          <div className="separator"></div>
          <div className="m-frmGroup total">
            <p className="ht-body-bold">Documento de identificación</p>
          </div>
          <div className="m-frmGroup">
            <label for="tipoDocumento">Tipo de documento</label>
            <select className="" name="user[document]" id="user_document" value={userData.doctype} onChange={handleDocTypeChange}>
              <option value="D">DNI</option>
              <option value="C">Certificado de residencia</option>
              <option value="F">Tarj. familiar UE</option>
              <option value="I">NIE</option>
              <option value="P">Pasaporte Español</option>
              <option value="S">Doc Ident. Schengen</option>
              <option value="T">Pasaporte extranjero</option>
              <option value="-">Sin documento</option>
            </select>
          </div>
          <div className="m-frmGroup">
            <label for="numeroDocumento">Número de documento</label>
            <input placeholder="Número de documento" type="text" name="user[num_document]" id="user_num_document" value={userData.docNumber} onChange={handleDocNumberChange}/>
          </div>
          <div className="m-frmGroup m-frmNaci">
            <span className="m-frmNaci__tit">Fecha de expiración</span>
              <div className="m-frmGroup m-frmGroup--min">
              <label for="mesNac">Mes</label>
              <select name="exp_date_month" id="exp_date_month" value={userData.exp_date_month} onChange={handleDocExpirationMonthChange}>
                <option value="1">Enero</option>
                <option value="2">Febrero</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
            </div>
            <div className="m-frmGroup m-frmGroup--min">
              <label for="anoNac">Año</label>
              <select id="exp_date_year" name="exp_date_year" value={userData.exp_date_year} onChange={handleDocExpirationYearChange}>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
                <option value="2035">2035</option>
                <option value="2036">2036</option>
                <option value="2037">2037</option>
                <option value="2038">2038</option>
                <option value="2039">2039</option>
                <option value="2040">2040</option>
                <option value="2041">2041</option>
                <option value="2042">2042</option>
                <option value="2043">2043</option>
                <option value="2044">2044</option>
              </select>
            </div>
          </div>
          <div className="m-frmGroup">
            <label for="nacionalidad">Nacionalidad</label>
            <select class="" name="user[nationality]" id="user_nationality" value={userData.nationality} onChange={handleNationalityChange}>
              <option value="ESP">España</option>
              <option value="ALB">Albania</option>
              <option value="AND">Andorra</option>
              <option value="ARE">Emiratos Arabes Unidos</option>
              <option value="ARG">Argentina</option>
              <option value="ARM">Armenia</option>
              <option value="AUS">Australia</option>
              <option value="AUT">Austria</option>
              <option value="AZE">Azerbaiyan</option>
              <option value="BEL">Belgica</option>
              <option value="BGR">Bulgaria</option>
              <option value="BHS">Bahamas</option>
              <option value="BIH">Bosnia Herzegovina</option>
              <option value="BLR">Bielorrusia</option>
              <option value="BLZ">Belice</option>
              <option value="BOL">Bolivia</option>
              <option value="BRA">Brasil</option>
              <option value="BRB">Barbados</option>
              <option value="CAN">Canada</option>
              <option value="CHE">Suiza</option>
              <option value="CHL">Chile</option>
              <option value="CHN">China</option>
              <option value="COL">Colombia</option>
              <option value="CRI">Costa Rica</option>
              <option value="CUB">Cuba</option>
              <option value="CYP">Chipre</option>
              <option value="CZE">Rep. Checa</option>
              <option value="DEU">Alemania</option>
              <option value="DMA">Dominica</option>
              <option value="DNK">Dinamarca</option>
              <option value="DOM">Republica Dominicana</option>
              <option value="DZA">Argelia</option>
              <option value="ECU">Ecuador</option>
              <option value="EGY">Egipto</option>
              <option value="EST">Estonia</option>
              <option value="FIN">Finlandia</option>
              <option value="FRA">Francia</option>
              <option value="GBR">Gran Bretana</option>
              <option value="GEO">Georgia</option>
              <option value="GNQ">Guinea Ecuatorial</option>
              <option value="GRC">Grecia</option>
              <option value="GRD">Granada</option>
              <option value="GTM">Guatemala</option>
              <option value="GUY">Guyana</option>
              <option value="HKG">Hong Kong</option>
              <option value="HND">Honduras</option>
              <option value="HRV">Croacia</option>
              <option value="HTI">Haiti</option>
              <option value="HUN">Hungria</option>
              <option value="IDN">Indonesia</option>
              <option value="IND">India</option>
              <option value="IRL">Irlanda</option>
              <option value="IRN">Iran</option>
              <option value="IRQ">Iraq</option>
              <option value="ISL">Islandia</option>
              <option value="ISR">Israel</option>
              <option value="ITA">Italia</option>
              <option value="JAM">Jamaica</option>
              <option value="JPN">Japon</option>
              <option value="KOR">Corea del Sur</option>
              <option value="KWT">Kuwait</option>
              <option value="LBN">Libano</option>
              <option value="LBY">Libia</option>
              <option value="LIE">Liechtenstein</option>
              <option value="LKA">Sri Lanka</option>
              <option value="LTU">Lituania</option>
              <option value="LUX">Luxemburgo</option>
              <option value="LVA">Letonia</option>
              <option value="MAR">Marruecos</option>
              <option value="MCO">Monaco</option>
              <option value="MDA">Moldavia</option>
              <option value="MEX">Mexico</option>
              <option value="MKD">Macedonia, Republica</option>
              <option value="MLT">Malta</option>
              <option value="MRT">Mauritania</option>
              <option value="MUS">Mauricio</option>
              <option value="MWI">Malawi</option>
              <option value="MYS">Malasia</option>
              <option value="NCL">Nueva Caledonia</option>
              <option value="NIC">Nicaragua</option>
              <option value="NLD">Holanda</option>
              <option value="NOR">Noruega</option>
              <option value="NZL">Nueva Zelanda</option>
              <option value="OMN">Oman</option>
              <option value="PAK">Pakistan</option>
              <option value="PAN">Panama</option>
              <option value="PER">Peru</option>
              <option value="PHL">Filipinas</option>
              <option value="PNG">Papua Nueva Guinea</option>
              <option value="POL">Polonia</option>
              <option value="PRI">Puerto Rico</option>
              <option value="PRK">Corea del Norte</option>
              <option value="PRT">Portugal</option>
              <option value="PRY">Paraguay</option>
              <option value="QTA">Qatar</option>
              <option value="ROU">Rumania</option>
              <option value="RUS">Rusia</option>
              <option value="SAU">Arabia Saudi</option>
              <option value="SGP">Singapur</option>
              <option value="SLV">El Salvador</option>
              <option value="STP">Santo Tome y Principe</option>
              <option value="SVK">Eslovaquia</option>
              <option value="SVN">Eslovenia</option>
              <option value="SWE">Suecia</option>
              <option value="SYC">Seychelles</option>
              <option value="SYR">Siria</option>
              <option value="THA">Tailandia</option>
              <option value="TTO">Trinidad y Tobago</option>
              <option value="TUN">Tunez</option>
              <option value="TUR">Turquia</option>
              <option value="TWN">Taiwan</option>
              <option value="UKR">Ucrania</option>
              <option value="URY">Uruguay</option>
              <option value="USA">Estados Unidos</option>
              <option value="VAT">Vaticano</option>
              <option value="VEN">Venezuela</option>
              <option value="VNM">Vietnam</option>
              <option value="YUG">Yugoslavia</option>
              <option value="ZAF">Africa del Sur</option></select>
          </div>
          <div className="separator"></div>
          <div className="btnOrange-l" onClick={() => handleEdit()}>Guardar cambios</div>
        </div>
      </div>
    </>
  )
}